import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";

const initialValues = [
  {    
    parent_item_code:'',
    mat_code:'',
    mat_name:'',
    qty: 0, 
    qty_after_lost: 0,
    level:0,
    typename:'',
    unit:'',
    multiply: 0,
    wt_in_process: 0,
    yield: 0,
    method:'',
    percent: 0.00,
    seq: 1,
  },
];

const bomSlice = createSlice({
  name: "bom-data",
  initialState: initialValues,
  reducers: {
    addBomDetail: (state, action) => {

      const newValues = [...current(state),action.payload];
      // console.log(newValues)
      const total_qty = newValues.reduce((sum, item) => sum + Number(item.qty/100 || 0),0);
      const total_qty_after_lost = newValues.reduce((sum, item) => sum + Number(((item.qty/item.yield)*100)/100 || 0),0);
      
      state.splice(0, state.length);
      newValues.forEach((element) => {
        const qty_after_lost = (element.qty/element.yield)*100 || 0; // คำนวณน้ำหนักหลังสูญเสีย
        state.push({
          seq: state.length + 1,
          qty: element.qty,
          qty_after_lost: qty_after_lost,
          mat_code: element.mat_code,
          mat_name: element.mat_name,
          typename: element.typename,
          unit: element.unit,
          multiply: element.multiply,
          wt_in_process: element.wt_in_process,
          yield: element.yield,
          method: element.method,
          percent: total_qty > 0 ? (Number( element.qty/100 || 0)/total_qty)*100 : 0, // คำนวณ percent
          totalpercent: total_qty_after_lost > 0 ? (Number(qty_after_lost/100 || 0)/total_qty_after_lost)*100  : 0, // คำนวณ percent
        });
      });
    },

    setValue: (state, action) => {
      state.splice(0, state.length);
      const newValues = action.payload;
        //  console.log(newValues)
      // คำนวณผลรวมของ qty
      const total_qty = newValues.reduce((sum, item) => sum + Number(item.qty/100 || 0),0);
      const total_qty_after_lost = newValues.reduce((sum, item) => sum + Number(((item.qty/item.yield)*100)/100 || 0),0);

      newValues.forEach((element) => {
        const qty_after_lost = (element.qty/element.yield)*100 || 0; // คำนวณน้ำหนักหลังสูญเสีย
        
        state.push({
          seq: state.length + 1,
          qty: element.qty,
          qty_after_lost: qty_after_lost,
          mat_code: element.mat_code,
          mat_name: element.mat_name,
          typename: element.typename,
          unit: element.unit,
          multiply: element.multiply,
          wt_in_process: element.wt_in_process,
          yield: element.yield,
          method: element.method,
          percent: total_qty > 0 ? (Number( element.qty/100 || 0)/total_qty)*100 : 0, // คำนวณ percent
          totalpercent: total_qty_after_lost > 0 ? (Number(qty_after_lost/100 || 0)/total_qty_after_lost)*100  : 0, // คำนวณ percent
        });
      });
    },
    // setLost: (state, action) => {
    //   // state.splice(0, state.length);
    //   const newValues = action.payload;
    //      console.log(newValues)
    //   // คำนวณผลรวมของ qty
    //   state.push(
    //     current(state),
    //       lost: newValues
    //   );
    //   // state.lost=newValues
    //   console.log(current(state))
    // },
  },
});

export const {
  addBomDetail,
  updateDetailWithIndex,
  setValue,
} = bomSlice.actions;
export const bomSelector = (store) => store.bomSlice;
export default bomSlice.reducer;
